import React from 'react';
import PropTypes from 'prop-types';

// components
import { ComponentLoader } from '../../../global/ComponentLoader/ComponentLoader';

function importFunc() {
    return import(
        /* webpackChunkName: "PdpRespNotificationMultiplePdpVisitsModal" */
        './PdpSharedNotificationMultiplePdpVisitsModal'
    ).then(moduleExport => moduleExport.PdpSharedNotificationMultiplePdpVisitsModal);
}

const PdpSharedNotificationMultiplePdpVisitsModalLoader = props => {
    return (
        <ComponentLoader
            {...props}
            useLoadingComponent={false}
            importFunc={importFunc}
            load={props.isEnabled}
        />
    );
};

PdpSharedNotificationMultiplePdpVisitsModalLoader.propTypes = {
    environment: PropTypes.object.isRequired,
    isEnabled: PropTypes.bool.isRequired,
    itemId: PropTypes.string.isRequired,
};

export { PdpSharedNotificationMultiplePdpVisitsModalLoader };
